export const URGENCY_THRESHOLDS = {
  CRITICAL: 10,
  HIGH: 5,
  MEDIUM: 2,
} as const

export type UrgencyLevel = 'low' | 'medium' | 'high' | 'critical'

export const getUrgencyLevel = (count: number): UrgencyLevel => {
  switch (true) {
    case count >= URGENCY_THRESHOLDS.CRITICAL:
      return 'critical'
    case count >= URGENCY_THRESHOLDS.HIGH:
      return 'high'
    case count >= URGENCY_THRESHOLDS.MEDIUM:
      return 'medium'
    default:
      return 'low'
  }
}
